<section
  *ngIf="(serviceList$ | async)?.length"
  class="promotional-banner-squidex"
  [ngClass]="styleClass"
  [attr.id]="customId || null"
>
  <div class="box-container">
    <ng-container *ngFor="let banner of serviceList$ | async">
      <ng-container *ngIf="banner.data.image.iv; else localization">
        <a href="{{ banner.data.link.iv }}" target="_blank" rel="noopener noreferrer">
          <picture class="desktop-banner">
            <source [srcset]="banner.data.imageWebP.iv" type="image/webp" />
            <img
              [src]="banner.data.image.iv"
              width="100%"
              class="banner-image"
              [alt]="banner.data.alt.iv"
              loading="lazy"
            />
          </picture>
          <picture class="mobile-banner">
            <source [srcset]="banner.data.imageMobileWebP.iv" type="image/webp" />
            <img
              [src]="banner.data.imageMobile.iv"
              width="100%"
              class="banner-image"
              [alt]="banner.data.alt.iv"
              loading="lazy"
            />
          </picture>
        </a>
      </ng-container>

      <ng-template #localization>
        <a href="{{ banner.data.link.iv }}" target="_blank" rel="noopener noreferrer">
          <picture class="desktop-banner">
            <source
              [srcset]="translate.currentLang === 'th' ? banner.data.imageWebP.th : banner.data.imageWebP.en"
              type="image/webp"
            />
            <img
              [src]="translate.currentLang === 'th' ? banner.data.image.th : banner.data.image.en"
              width="100%"
              class="banner-image"
              [alt]="banner.data.alt.iv"
              loading="lazy"
            />
          </picture>
          <picture class="mobile-banner">
            <source
              [srcset]="
                translate.currentLang === 'th' ? banner.data.imageMobileWebP.th : banner.data.imageMobileWebP.en
              "
              type="image/webp"
            />
            <img
              [src]="translate.currentLang === 'th' ? banner.data.imageMobile.th : banner.data.imageMobile.en"
              width="100%"
              class="banner-image"
              [alt]="banner.data.alt.iv"
              loading="lazy"
            />
          </picture>
        </a>
      </ng-template>
    </ng-container>
  </div>
</section>
